

// store.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    content: "" // 存储需要刷新的内容的变量
  },
  mutations: {
    setContent(state, content) {
      state.content = content
    }
  },
  actions: {
    setContent({ commit }, content) {
      commit('setContent', content)
    }
  }
})


